import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import CvDetails from "./Components/CvDetails";
import ErrorPage from "./Components/ErrorPage";
import CvReview from "./Components/CvReview";
import Instructions from "./Components/Instructions";
import ScrollToTop from "./Components/ScrollToTop";
import Login from "./Components/Login"
import SignUp from "./Components/SignUp";
import Verification from "./Components/Verification";
import SignUpEmailVerification from "./Components/SignUpEmailVerification";
import ProtectedRoutes from "./Components/ProtectedRoutes/ProtectedRoutes";
import { AuthProvider } from "./context/AuthProvider";
import NoMatch from "./Components/NoMatch";
import { createTheme, ThemeProvider } from "@mui/material";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: 'Poppins'
    },
  });
  return (
    <div className="relative">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop>
              <Navbar/>
              <Routes>
                <Route path="/" element={<Home />} errorElement={<ErrorPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signUp" element={<SignUp />} />
                <Route path="/verify-account" element={<Verification />} />
                <Route path="/verification-confirmation" element={<SignUpEmailVerification />} />
                <Route element={<ProtectedRoutes />} >
                  <Route path="/guides-and-instructions" element={<Instructions />} />
                  <Route path="/create-cv" element={<CvDetails />} />
                  <Route path="/review-cv" element={<CvReview />} />
                </Route>
                <Route path="*" element={<NoMatch />} />
              </Routes>
            </ScrollToTop>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
